import React from 'react';
import PropTypes from 'prop-types';

class SectionLabel extends React.Component {   

    constructor(props){
        super(props);
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){
        return (
            <div className="SectionLabel">
                {this.props.children}
                <style jsx>{`
                    .SectionLabel { 
                        font-size: 14px;
                        text-transform: uppercase;
                        margin-top : ${this.props.marginTop || 0}px;
                        margin-bottom : ${this.props.marginBottom || 0}px;
                        padding: 2px;
                        padding-left: 6px;
                        background: #ccc;
                        color: #fff;
                        border-radius: 0px 20px 20px 0px;
                        font-weight: 700;
                    }
                `}</style>
            </div>
        )
    }
}

SectionLabel.propTypes = {
    marginTop : PropTypes.string,
    marginBottom : PropTypes.string,
}

export default SectionLabel;


// WEBPACK FOOTER //
// ./src/components/common/SectionLabel.js